import Link from "next/link";
import {withRouter} from "next/router";
import {NextSeo} from "next-seo";
import React from "react";
import styled from "styled-components";

import {get_award} from "../../../api/awards";
import Page from "../../../components/Page";
import WinItem from "../../../components/WinItem";
import {device} from "../../../constants/media";
import t from "../../../utils/locale";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 50px auto;
`;

const Info = styled.div`
  @media ${device.below.tablet} {
    max-width: 80%;
  }

  max-width: 800px;
  display: flex;
  flex-direction: column;
  margin: auto;
`;

const Back = styled.div`
  border-bottom: solid 1px #ccc;
  color: #999;
  direction: rtl;
  display: flex;
  flex-direction: row;
  font-family: "BMitraRegular", "Times New Roman", Times, serif;
  font-size: 16px;
  margin-bottom: 40px;
  padding-bottom: 3px;
  width: max-content;

  a {
    border: none;
    color: inherit;
    text-decoration: inherit;
  }

  &:hover {
    border-bottom: solid 1px #06c;
    color: #06c;
  }

  &:focus {
    border-bottom: solid 1px #06c;
  }
`;

const AwardInfo = styled.div`
  @media ${device.below.tablet} {
    flex-direction: column;
    max-width: 80%;
  }

  display: flex;
  max-width: 800px;
`;

const AwardText = styled.div`
  border-top: solid 3px #000;
`;

const AwardLogo = styled.a`
  @media ${device.below.tablet} {
    margin: auto;
    width: 80%;
  }

  color: black;
  display: flex;
  flex-direction: column;
  margin: 0 2rem;
  max-width: 170px;
  text-align: center;
  text-decoration: none;
`;

const Image = styled.img`
  margin: 0;
  max-width: 170px;
`;

const Title = styled.h1`
  font-size: 0.85em;
  margin: 0;
  width: 100%;
`;

const Organizer = styled.h2`
  color: #aaa;
  font-size: 0.6em;
  margin: 0;
`;

const Wins = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 2rem;
`;

class People extends React.Component {
  render() {
    const award = this.props.award;
    return (
      <Page>
        <NextSeo title={award.title} description={award.title} />

        <Container>
          <Info>
            <Back>
              <Link href={"/practice/awards"}>
                {t(this.props.router.locale, "Back To ") + t(this.props.router.locale, "Awards")}
              </Link>
            </Back>

            <AwardInfo>
              <AwardLogo href={award.link} target="_blank">
                <Image src={award.cover} alt={award.title} />
                <Title>{award.title}</Title>
                <Organizer>{award.organizer}</Organizer>
              </AwardLogo>
              <AwardText dangerouslySetInnerHTML={{__html: award.text}} />
            </AwardInfo>
          </Info>

          {award.win_set.length > 0 && (
            <Wins>
              {award.win_set.map(win => (
                <WinItem key={win.id} win={win} />
              ))}
            </Wins>
          )}
        </Container>
      </Page>
    );
  }
}

export async function getServerSideProps(context) {
  try {
    const language = context.locale || "en";
    const {slug} = context.query;
    const award = await get_award(slug, language);

    if (award.detail && award.detail === "Not found.") {
      return {
        notFound: true,
      };
    }

    return {props: {award}};
  } catch (e) {
    console.log(e);
    return {
      notFound: true,
    };
  }
}

export default withRouter(People);
